export function fetching() {
    return {
        type: 'SEARCH_FETCHING',
    };
}

export function fetched(payload) {
    return {
        type: 'SEARCH_FETCHED',
        payload
    };
}

export function error(payload) {
    return {
        type: 'SEARCH_ERROR',
        payload
    };
}

export function searchCountFetching() {
    return {
        type: 'SEARCH_COUNT_FETCHING',
    };
}

export function searchCountFetched(payload) {
    return {
        type: 'SEARCH_COUNT_FETCHED',
        payload
    };
}

export function searchCountError(payload) {
    return {
        type: 'SEARCH_COUNT_ERROR',
        payload
    };
}



// WEBPACK FOOTER //
// ./src/app/actions/search.js